import { Factory } from 'fishery';

import {
	DeviceCompatibilityLevel,
	DeviceModel,
	DeviceStatus,
	MissingFeatureType
} from '@shure/shared/angular/data-access/system-api/models';

import { InventoryDevice } from '../inventory-device';
import { SortedDeviceConditionCollection } from '../sorted-device-condition-collection';

class InventoryDeviceFactory extends Factory<InventoryDevice> {
	/**
	 * Adds a supported (i.e. isMissing = false) feature to the device.
	 * @example ```
	 * const device = inventoryDeviceFactory
	 *   .withFeature('audioChannelCount', { count: 1 })
	 *   .build();
	 * ```
	 */
	public withFeature<TKey extends keyof InventoryDevice['features']>(
		featureKey: TKey,
		featureData: Omit<NonNullable<InventoryDevice['features'][TKey]>, keyof MissingFeatureType>
	): this {
		return this.params({
			features: {
				[featureKey]: {
					isMissing: false,
					...featureData
				}
			}
		});
	}
}

export const inventoryDeviceFactory = InventoryDeviceFactory.define(({ sequence }) => ({
	id: sequence.toString(),
	hardwareId: `hardware-id-${sequence}`,
	name: `Inventory-Device-${sequence}`,
	model: DeviceModel.P300,
	status: DeviceStatus.Online,
	compatibility: DeviceCompatibilityLevel.CompatibleLatest,
	virtual: false,
	manufacturer: 'Shure',
	conditions: new SortedDeviceConditionCollection(),
	features: {}
}));
